




































































import { PropType } from 'vue'
import { defineComponent } from 'vue-demi'

import {
  DISCOUNT_EFFECT,
  EFFECT_FIRST_PET_2_EUROS,
  EFFECT_FIRST_PET_5_EUROS,
  GODFATHER_PROMOCODE_2_EUROS_EFFECT,
  GODFATHER_PROMOCODE_5_EUROS_EFFECT,
} from '@front/common/promo-codes'
import { DiscountType, Item, PromoCode } from '@front/common/types'
import {
  centsToEuro,
  formatPrice,
  getItemsTotalPrice,
  isArrayEmpty,
  isDiscountType,
  isGiftCard,
  priceAfterPercentageDiscount,
} from '@front/common/utils'
import { Button, Tag, TextInput, Typography } from '@front/ui'

export default defineComponent({
  components: {
    Typography,
    TextInput,
    Button,
    Tag,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array as PropType<Item[]>,
      default: null,
    },
    disableFees: {
      type: Boolean,
      default: false,
    },
    promoCode: {
      type: Object as PropType<PromoCode>,
      default: null,
    },
    shippingFees: {
      type: Number,
      default: null,
    },
    inputStyle: {
      type: [String, Object],
      default: null,
    },
    wrapperStyle: {
      type: [String, Object],
      default: null,
    },
  },
  data() {
    return {
      promoCodeInput: '',
    }
  },
  computed: {
    hasPromoCodeRegistered(): boolean {
      return this.promoCode
    },
    isGiftCard() {
      return isGiftCard(this.promoCode)
    },
    discountEffect() {
      return (
        this.promoCode?.effects.find(({ type }) => {
          return type === DISCOUNT_EFFECT
        }) || null
      )
    },
    afterDiscountRemainingCash() {
      if (!this.discountEffect || isArrayEmpty(this.items)) {
        return 0
      }

      const itemsPrice = this.disableFees
        ? getItemsTotalPrice(this.items)
        : getItemsTotalPrice(this.items) + this.shippingFees

      return isDiscountType(this.discountEffect.data, DiscountType.percentage)
        ? priceAfterPercentageDiscount(
            itemsPrice,
            this.discountEffect.data.value,
          )
        : Math.max(0, centsToEuro(this.discountEffect.data.value) - itemsPrice)
    },
    formattedAfterDiscountRemainingCash() {
      return formatPrice(this.afterDiscountRemainingCash)
    },
    hasGodFatherPromotion() {
      return this.promoCode?.effects.some(({ type }) => {
        return (
          type === GODFATHER_PROMOCODE_2_EUROS_EFFECT ||
          type === EFFECT_FIRST_PET_2_EUROS ||
          type === GODFATHER_PROMOCODE_5_EUROS_EFFECT ||
          type === EFFECT_FIRST_PET_5_EUROS
        )
      })
    },
  },
  methods: {
    deletePromoCode() {
      this.$emit('deletePromoCode')
    },
    handlePromoCodeInput({ target }) {
      this.promoCodeInput = target.value
    },
    // eslint-disable-next-line vue/no-unused-properties
    clearInput() {
      this.promoCodeInput = ''
      if (this.$refs.promoCodeInput) {
        this.$refs.promoCodeInput.$el.querySelector('input').value = ''
      }
    },
    async addPromoCode(promoCodeInput) {
      const promoCode =
        typeof promoCodeInput === 'string'
          ? promoCodeInput
          : this.promoCodeInput

      if (promoCode === '') {
        return
      }

      this.$emit('addPromoCode', promoCode)
    },
  },
})
